// extracted by mini-css-extract-plugin
module.exports = {"action_wrapper":"SuspendedButton_action_wrapper__u9UZT"};